import {Box, TextField} from '@mui/material';
import React, {useEffect} from 'react';
import {ANALYSIS_DESCRIPTION_MAX_CHARS, ANALYSIS_NAME_MAX_CHARS} from '../../constants';

interface Step0Props {
    formData: {
        name: string;
        description: string;
    };
    setFormData: React.Dispatch<React.SetStateAction<any>>;
    /** Set whether the form is valid and can proceed to the next step */
    handleNext: (isValid: boolean) => void;
    error?: string;
    setError?: (error: string) => void;
    data?: any;
}

/**
 * Lets the user enter the name and description of the analysis.
 */
function Step0({formData, setFormData, handleNext}: Step0Props) {
    const handleInputChange = (e: any) => {
        const {name, value} = e.target;
        setFormData({...formData, [name]: value});
    };

    useEffect(() => {
        formData.name.trim().length > 2 ? handleNext(true) : handleNext(false);
    }, [formData]);

    return (
        <Box
            p={3}
            my={1}
            sx={{bgcolor: 'surface-container-lowest', borderRadius: '10px', display: 'flex', flexDirection: 'column', gap: 3}}>
            <TextField
                name="name"
                label="Analysis Name"
                fullWidth
                value={formData.name}
                placeholder="Enter a name"
                onChange={handleInputChange}
                inputProps={{maxLength: ANALYSIS_NAME_MAX_CHARS}}
            />

            <TextField
                name="description"
                label="Description (optional)"
                fullWidth
                value={formData.description}
                placeholder="Enter a description"
                onChange={handleInputChange}
                inputProps={{maxLength: ANALYSIS_DESCRIPTION_MAX_CHARS}}
            />
        </Box>
    );
}

export default Step0;
